import React from "react";

export const MainFrame = () => {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 348 438"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M341.241 0H313.951L310.43 3.54535H292L293.564 5.90929H312.427L314.186 4.13607H340.883L345.578 13H348L341.241 0Z"
        fill="#7F5CFF"
      />
      <path
        d="M341.241 438H313.951L310.43 434.455H292L293.564 432.091H312.427L314.186 433.864H340.883L345.578 425H348L341.241 438Z"
        fill="#7F5CFF"
      />
      <path
        d="M6.75907 0H34.0489L37.5697 3.54535H56L54.4357 5.90929H35.5735L33.8136 4.13607H7.11684L2.42171 13H0L6.75907 0Z"
        fill="#7F5CFF"
      />
      <path
        d="M6.75907 438H34.0489L37.5697 434.455H56L54.4357 432.091H35.5735L33.8136 433.864H7.11684L2.42171 425H0L6.75907 438Z"
        fill="#7F5CFF"
      />
      <path d="M292.75 6H55.5002L57.0002 3.5H291L292.75 6Z" fill="#7F5CFF" />
      <path
        d="M292.75 432H55.5002L57.0002 434.5H291L292.75 432Z"
        fill="#7F5CFF"
      />
      <mask id="path-7-inside-1_4007_25897" fill="white">
        <path d="M35 8.04102H313L315 6H340L344 14.1631H348V424H344L340 432H315L313 430H35L33 432H9L4 424H0V14.1631H4L8 6H33L35 8.04102Z" />
      </mask>
      <path
        d="M35 8.04102L34.2858 8.74091L34.5798 9.04102H35V8.04102ZM313 8.04102V9.04102H313.42L313.714 8.74091L313 8.04102ZM315 6V5H314.58L314.286 5.30011L315 6ZM340 6L340.898 5.55998L340.624 5H340V6ZM344 14.1631L343.102 14.6031L343.376 15.1631H344V14.1631ZM348 14.1631H349V13.1631H348V14.1631ZM348 424V425H349V424H348ZM344 424V423H343.382L343.106 423.553L344 424ZM340 432V433H340.618L340.894 432.447L340 432ZM315 432L314.293 432.707L314.586 433H315V432ZM313 430L313.707 429.293L313.414 429H313V430ZM35 430V429H34.5858L34.2929 429.293L35 430ZM33 432V433H33.4142L33.7071 432.707L33 432ZM9 432L8.152 432.53L8.44575 433H9V432ZM4 424L4.848 423.47L4.55425 423H4V424ZM0 424H-1V425H0V424ZM0 14.1631V13.1631H-1V14.1631H0ZM4 14.1631V15.1631H4.62359L4.89799 14.6031L4 14.1631ZM8 6V5H7.37641L7.10201 5.55998L8 6ZM33 6L33.7142 5.30011L33.4202 5H33V6ZM35 8.04102V9.04102H313V8.04102V7.04102H35V8.04102ZM313 8.04102L313.714 8.74091L315.714 6.69989L315 6L314.286 5.30011L312.286 7.34112L313 8.04102ZM315 6V7H340V6V5H315V6ZM340 6L339.102 6.44002L343.102 14.6031L344 14.1631L344.898 13.7231L340.898 5.55998L340 6ZM344 14.1631V15.1631H348V14.1631V13.1631H344V14.1631ZM348 14.1631H347V424H348H349V14.1631H348ZM348 424V423H344V424V425H348V424ZM344 424L343.106 423.553L339.106 431.553L340 432L340.894 432.447L344.894 424.447L344 424ZM340 432V431H315V432V433H340V432ZM315 432L315.707 431.293L313.707 429.293L313 430L312.293 430.707L314.293 432.707L315 432ZM313 430V429H35V430V431H313V430ZM35 430L34.2929 429.293L32.2929 431.293L33 432L33.7071 432.707L35.7071 430.707L35 430ZM33 432V431H9V432V433H33V432ZM9 432L9.848 431.47L4.848 423.47L4 424L3.152 424.53L8.152 432.53L9 432ZM4 424V423H0V424V425H4V424ZM0 424H1V14.1631H0H-1V424H0ZM0 14.1631V15.1631H4V14.1631V13.1631H0V14.1631ZM4 14.1631L4.89799 14.6031L8.89799 6.44002L8 6L7.10201 5.55998L3.10201 13.7231L4 14.1631ZM8 6V7H33V6V5H8V6ZM33 6L32.2858 6.69989L34.2858 8.74091L35 8.04102L35.7142 7.34112L33.7142 5.30011L33 6Z"
        fill="#7F5CFF"
        mask="url(#path-7-inside-1_4007_25897)"
      />
    </svg>
  );
};
